angular.module('bookAndPay').directive('integrapayForm', function() {
  return {
    restrict: 'EA',
    template: require('templates/book_and_pay/integrapay_form.html.slim'),
    scope: {
      cart: '=',
      months: '=',
      years: '=',
      currency: '=',
      expired: '=',
      toNewCart: '&'
    },
    controller: ["$scope", "$timeout", function($scope, $timeout) {
      var loadIntegrapayScript;
      $scope.card = {};
      $scope.pageParams = {};
      loadIntegrapayScript = function() {
        var script;
        if (document.querySelectorAll('#realtime_js_url').length) {
          return;
        }
        script = document.createElement('script');
        script.id = 'realtime_js_url';
        script.type = 'text/javascript';
        script.src = $scope.cart.realtime_js_url;
        return document.body.appendChild(script);
      };
      $scope.getActionUrl = function() {
        return `${window.location.origin}/websites/${window.DATA.domain}/book_and_pay/carts/${$scope.cart.cart_uuid}/handle_hosted_payment_result`;
      };
      $scope.onCardChange = function() {
        var ref;
        return $scope.card.number = (ref = $scope.card.number) != null ? ref.replace(/[^0-9]/g, '') : void 0;
      };
      $scope.onSubmit = function() {
        if ($scope.pageParams.isLoading || $scope.expired) {
          return;
        }
        $scope.pageParams.isLoading = true;
        return $timeout(function() {
          if (document.querySelectorAll("[data-integrapay='Errors']")[0].innerText) {
            return $scope.pageParams.isLoading = false;
          }
        }, 300);
      };
      return loadIntegrapayScript();
    }]
  };
});
